import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { preventDefault } from '../../utils';
import MenuOverlay from './MenuOverlay';
import MenuTopPanel from './MenuTopPanel';
import MenuBar from './MenuBar';
import Tabs from '../../molecules/Tabs/Tabs';

const PageMenu = ({
  menuLinks = [],
  menuId,
  isExpanded,
  onClickClose,
  onClickSearch,
  searchUrl,
  fixedPosition,
  isLoggedIn,
  menuSelectedTabIndex,
  onTabSelect,
  logoutLink = '#',
  onLogoutClick
}) => React.createElement("div", null, React.createElement("div", {
  className: classNames('page-menu', {
    'page-menu--fixed': fixedPosition
  }, {
    'page-menu--expanded': isExpanded
  }),
  id: menuId || 'page-header-menu'
}, React.createElement(MenuTopPanel, {
  isExpanded: isExpanded,
  menuId: menuId,
  onClickClose: onClickClose,
  onClickSearch: onClickSearch,
  searchUrl: searchUrl
}), React.createElement("nav", {
  "aria-label": "Main menu"
}, React.createElement("div", {
  className: "page-menu__selection"
}, React.createElement(Tabs, {
  uniqueId: "menu-tabs",
  onSelect: onTabSelect,
  selectedIndex: menuSelectedTabIndex,
  skipPanelRendering: true,
  noMargin: true,
  compact: true
}, menuLinks.map((menuLink, i) => React.createElement(Tabs.Tab, {
  key: i,
  heading: menuLink.heading
})))), menuLinks.map((menuLink, i) => React.createElement(Tabs.TabPanel, {
  key: i,
  index: i,
  uniqueId: "separated-tabs",
  isSelected: menuSelectedTabIndex === i
}, React.createElement("div", {
  className: classNames('page-menu__content', {
    'page-menu__content--empty': !menuLink.contentAboveItems
  }),
  dangerouslySetInnerHTML: {
    __html: menuLink.contentAboveItems
  }
}), React.createElement(MenuBar, {
  ariaLabel: "innlogget brukermeny",
  items: menuLink.loggedInLinks,
  isEmphasised: true
}), React.createElement(MenuBar, {
  items: menuLink.loggedOutLinks
}))), isLoggedIn && React.createElement("ul", {
  className: "page-menu__item-list"
}, React.createElement("li", {
  className: "page-menu__item"
}, React.createElement("div", {
  className: "page-menu__item-link"
}, React.createElement("a", {
  className: "page-menu__log-out-button link",
  href: logoutLink,
  onClick: preventDefault(onLogoutClick)
}, "Logg ut")))))), fixedPosition && React.createElement(MenuOverlay, {
  onClick: onClickClose,
  active: isExpanded
}));

PageMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  menuLinks: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    loggedInLinks: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      icon: PropTypes.string
    })),
    loggedOutLinks: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      icon: PropTypes.string
    }))
  })),
  menuId: PropTypes.string,
  isExpanded: PropTypes.bool,
  onClickClose: PropTypes.func,
  onClickSearch: PropTypes.func,
  searchUrl: PropTypes.string,
  logoutLink: PropTypes.string,
  fixedPosition: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  menuSelectedTabIndex: PropTypes.number,
  onTabSelect: PropTypes.func
} : {};
export default PageMenu;